import s from "./NoneData.module.scss";
import { FC } from "react";
type NoneDataT = {
  text: string;
};
export const NoneData: FC<NoneDataT> = ({ text }) => {
  return <div className={s.hint}>{text}</div>;
};
